import create from 'zustand';
import { Vermin, Damage, Indpin, Trap, Camera, Prevention_faci, Report} from 'src/pages/Data/Data'

type Store = {
  verminData: Vermin | null,
  setEditVerminData: (verminData: Vermin) => void;
  deleteEditVerminData: () => void;
  damageData: Damage | null,
  setEditDamageData: (damageData: Damage) => void;
  deleteEditDamageData: () => void;
  indpinData: Indpin | null,
  setEditIndpinData: (indpinData: Indpin) => void;
  deleteEditIndpinData: () => void;
  trapData: Trap | null,
  setEditTrapData: (trapData: Trap) => void;
  deleteEditTrapData: () => void;
  cameraData: Camera | null,
  setEditCameraData: (cameraData: Camera) => void;
  deleteEditCameraData: () => void;
  prevData: Prevention_faci | null,//柵用20230412追記
  setEditPrevData: (PrevData: Prevention_faci) => void;
  deleteEditPrevData: () => void;
  // ↓ 20240410 Add_Uduki 報告書用
  reportData: Report | null,
  setEditReportData: (PrevData: Report) => void;
  deleteEditReportData: () => void;
  // ↑ 20240410 Add_Uduki 報告書用
  latLng: {
    lat: number;
    lng: number;
  } | null;
  setLatLng: (latLng: { lat: number, lng: number }) => void;
  deleteLatLng: () => void;
  expPictureData: string | null,//画像20230407追記
  setexpPictureData: (PictureDate: string) => void;
  deleteexpPictureData: () => void;
  Line: any[] | null;//柵用20230412追記
  setLine: (Lines: any[]) => void;
  deleteLine: () => void;
  Page: string|null;//柵用20230412追記
  setPage: (Pages: string|null) => void;
  deletePage: () => void;
};

/**
 * 検索結果管理ストア
 */
const useEditData = create<Store>(set => ({
  verminData: null,
  setEditVerminData: verminData => set({ verminData: verminData }),
  deleteEditVerminData: () => set({ verminData: null }),
  damageData: null,
  setEditDamageData: DamageData => set({ damageData: DamageData }),
  deleteEditDamageData: () => set({ damageData: null }),
  indpinData: null,
  setEditIndpinData: IndpinData => set({ indpinData: IndpinData }),
  deleteEditIndpinData: () => set({ indpinData: null }),
  trapData: null,
  setEditTrapData: TrapData => set({ trapData: TrapData }),
  deleteEditTrapData: () => set({ trapData: null }),
  cameraData: null,
  setEditCameraData: CameraData => set({ cameraData: CameraData }),
  deleteEditCameraData: () => set({ cameraData: null }),
  prevData: null,//柵用20230412追記
  setEditPrevData: Prev => set({ prevData: Prev }),
  deleteEditPrevData: () => set({ prevData: null }),
  // ↓ 0240410 Add_Uduki 報告書用
  reportData: null,
  setEditReportData: Report => set({ reportData: Report }),
  deleteEditReportData: () => set({ reportData: null }),
  // ↑ 0240410 Add_Uduki 報告書用
  latLng: null,
  setLatLng: latLng => set({ latLng: latLng }),
  deleteLatLng: () => set({ latLng: null }),
  expPictureData: null,//画像20230407追記
  setexpPictureData: PictureData => set({expPictureData: PictureData}),
  deleteexpPictureData: () => set({ expPictureData: null }),
  Line: null,//柵用20230412追記
  setLine: Lines => set({ Line: Lines }),
  deleteLine: () => set({ Line: null }),
  Page: null,//柵用20230412追記
  setPage: Pages => set({ Page: Pages }),
  deletePage: () => set({ Page: null }),
}));

export default useEditData;